import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AfterContentInit, AfterViewInit } from '@angular/core';
import { HostListener } from '@angular/core';

@Directive({
  selector: '[appCopy]'
})

export class CopyDirective implements OnInit {

  @Input() copyElementId: string;
  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
  private translate: TranslateService ) {

  }

  ngOnInit(): void {
    this.renderer.addClass( this.element.nativeElement, 'input-group-addon' );
    this.renderer.addClass( this.element.nativeElement, 'copy-btn' );
    this.renderer.setAttribute( this.element.nativeElement, 'data-tooltip', 'Click to copy' );
    this.translate.get('CORE.DIRECTIVES.COPY').subscribe((text: string) => {
      this.element.nativeElement.innerHTML = text; // '<i class="fa fa-files-o" aria-hidden="true"></i>' + text;
    });

  }

  @HostListener('click') onclick() {
    if ( this.copyElementId ) {
      const copyElement =  <HTMLInputElement>document.getElementById(this.copyElementId);
      copyElement.focus();
      copyElement.select();
      document.execCommand('copy');
      this.clearSelection();
    }

    this.translate.get('CORE.DIRECTIVES.COPIED').subscribe((text: string) => {
      this.element.nativeElement.innerHTML = text; // '<i class="fa fa-files-o" aria-hidden="true"></i>' + text;
      this.renderer.addClass( this.element.nativeElement, 'copied-btn' );
    });

    setTimeout(() => {
      this.translate.get('CORE.DIRECTIVES.COPY').subscribe((text: string) => {
        this.element.nativeElement.innerHTML = text; // '<i class="fa fa-files-o" aria-hidden="true"></i>' + text;
        this.renderer.removeClass( this.element.nativeElement, 'copied-btn' );
      });
    }, 2000);

  }

  private  clearSelection() {
    if ( window.getSelection ) {
        window.getSelection().removeAllRanges();
    }
}


}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/directives/copy.directive.ts